import React from 'react'
import Image from 'next/image'
import { ArtistIntroCardType } from '~types'
import styles from './ArtistIntroCard.module.scss'
import { NEXT_IMAGE_QUALITY } from '~constants'
import { getImageUrl } from 'utils/assets/getImageUrl'

const ArtistIntroCard = ({ title, image, logoImage }: ArtistIntroCardType) => {
  const imageUrl = getImageUrl({ imageUrl: image?.url })
  const logoImageUrl = getImageUrl({ imageUrl: logoImage?.url })

  return (
    <div className={styles.container}>
      <div className={styles['logo-title-container']}>
        {title && <div className={styles.title}>{title}</div>}
        {logoImageUrl && (
          <div className={styles['logo-container']}>
            <Image alt={logoImage?.altText ?? 'logo'} src={logoImageUrl} fill quality={NEXT_IMAGE_QUALITY} />
          </div>
        )}
      </div>
      {imageUrl && <Image src={imageUrl} alt={image?.altText ?? ''} fill quality={NEXT_IMAGE_QUALITY} />}
    </div>
  )
}

export default ArtistIntroCard
